/* People's Peps: "Send me this stack" for both calculators.
   Markup: snippets/pp-calc-send.liquid. Works with any card that is
   [data-pp-calc] (concentration) or [data-pp-bac] (BAC water).

     reveal   the panel stays hidden until the visitor first changes
              something in the card (a real input, change or button press)
     send     the stack is written into the contact form (every
              [data-pp-stack] figure, in page order, plus a reopen link) and
              posted in the background to the store inbox; then the visitor
              is added to Customers with the panel's tags. If Shopify asks for
              a spam check, the form is posted the normal way instead.
     reopen   a link with the stack's keys (?p=...&mg=...) fills the card in
              on arrival, so the emailed link opens the same numbers

   One re-entry guard, handlers delegated on document, so it survives the
   theme editor re-rendering a section. */
(function () {
  if (window.__ppCalcSendWired) return;
  window.__ppCalcSendWired = true;

  var CARD = '[data-pp-calc],[data-pp-bac]';

  function card(el) { return el && el.closest ? el.closest(CARD) : null; }
  function panel(c) { return c ? c.querySelector('[data-pp-calc-send]') : null; }
  function inPanel(el) { return !!(el && el.closest && el.closest('[data-pp-calc-send]')); }
  function txt(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }

  /* ---------- reveal on first use ---------- */
  function reveal(c) {
    var p = panel(c);
    if (!p) return;
    if (p.hidden) p.hidden = false;
    /* after a send, changing a figure brings the field back for a new stack */
    var row = p.querySelector('[data-pp-calc-send-row]');
    if (row && row.hidden && p.getAttribute('data-sent') === '1') {
      row.hidden = false;
      p.removeAttribute('data-sent');
      say(p, '', false);
    }
  }
  function onUse(e) {
    if (!e.isTrusted) return;
    var c = card(e.target);
    if (!c || inPanel(e.target)) return;
    reveal(c);
  }
  document.addEventListener('input', onUse, true);
  document.addEventListener('change', onUse, true);
  document.addEventListener('click', function (e) {
    if (!e.isTrusted || !e.target.closest) return;
    var b = e.target.closest('button');
    if (!b || inPanel(b)) return;
    var c = card(b);
    if (c) reveal(c);
  }, true);

  /* ---------- the stack ---------- */
  function lines(c) {
    var out = [];
    Array.prototype.forEach.call(c.querySelectorAll('[data-pp-stack]'), function (el) {
      if (el.closest('[hidden]')) return;
      var label = el.getAttribute('data-pp-stack');
      var v;
      if (el.tagName === 'SELECT') {
        var o = el.options[el.selectedIndex];
        v = o ? o.text : '';
      } else if (el.tagName === 'INPUT') {
        v = el.value;
      } else {
        v = el.textContent;
      }
      v = String(v || '').replace(/\s+/g, ' ').trim();
      if (!v || v === '--') return;
      var unit = el.getAttribute('data-pp-stack-unit') || '';
      var us = el.getAttribute('data-pp-stack-unitsel');
      if (us) unit = txt(c.querySelector(us)) || unit;
      if (unit) v += ' ' + unit;
      var ex = el.getAttribute('data-pp-stack-extra');
      if (ex) {
        var e2 = txt(c.querySelector(ex));
        if (e2 && e2.indexOf('--') !== 0) v += ' (' + e2 + ')';
      }
      out.push((label ? label + ': ' : '') + v);
    });
    return out;
  }
  function link(c) {
    var p = new URLSearchParams();
    Array.prototype.forEach.call(c.querySelectorAll('[data-pp-stack-key]'), function (el) {
      var k = el.getAttribute('data-pp-stack-key');
      var v = '';
      if (el.hasAttribute('data-pp-stack-radio')) {
        var on = el.querySelector('[aria-pressed="true"][data-pp-stack-value]');
        v = on ? on.getAttribute('data-pp-stack-value') : '';
      } else {
        v = String(el.value || '').trim();
      }
      if (v) p.set(k, v);
    });
    var q = p.toString();
    return location.origin + location.pathname + (q ? '?' + q : '');
  }
  function compose(c, box) {
    var head = box.getAttribute('data-title') || document.title;
    var body = [head, ''].concat(lines(c));
    body.push('', (box.getAttribute('data-link-label') || '') + ': ' + link(c));
    return body.join('\n');
  }

  /* ---------- reopen from a link ---------- */
  function restore(c) {
    if (window.Shopify && window.Shopify.designMode) return false;
    var q;
    try { q = new URLSearchParams(location.search); } catch (e) { return false; }
    var any = false;
    function fire(el, type) { el.dispatchEvent(new Event(type, { bubbles: true })); }
    /* product first: picking it fills the vial content and weight */
    Array.prototype.forEach.call(c.querySelectorAll('select[data-pp-stack-key]'), function (el) {
      var v = q.get(el.getAttribute('data-pp-stack-key'));
      if (v === null) return;
      for (var i = 0; i < el.options.length; i++) {
        if (el.options[i].value === v) {
          if (el.selectedIndex !== i) { el.selectedIndex = i; fire(el, 'change'); }
          any = true;
          break;
        }
      }
    });
    /* then the unit, which rescales the amount it finds ... */
    Array.prototype.forEach.call(c.querySelectorAll('[data-pp-stack-radio][data-pp-stack-key]'), function (g) {
      var v = q.get(g.getAttribute('data-pp-stack-key'));
      if (!v) return;
      Array.prototype.forEach.call(g.querySelectorAll('[data-pp-stack-value]'), function (b) {
        if (b.getAttribute('data-pp-stack-value') === v && b.getAttribute('aria-pressed') !== 'true') b.click();
      });
      any = true;
    });
    /* ... so the typed figures go in last */
    Array.prototype.forEach.call(c.querySelectorAll('input[data-pp-stack-key]'), function (el) {
      var v = q.get(el.getAttribute('data-pp-stack-key'));
      if (v === null) return;
      el.value = v;
      fire(el, 'input');
      any = true;
    });
    return any;
  }

  /* pp-calc.js stops Enter in any calculator field from submitting, which
     would also block it in the email field; send the form from here. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target || !e.target.closest) return;
    var f = e.target.closest('[data-pp-calc-send-form]');
    if (!f || e.target.tagName !== 'INPUT') return;
    e.preventDefault();
    if (f.requestSubmit) f.requestSubmit();
    else { var b = f.querySelector('.pp-calcsend__btn'); if (b) b.click(); }
  }, true);

  /* ---------- send ---------- */
  function say(box, msg, ok) {
    var m = box.querySelector('[data-pp-calc-send-msg]');
    if (!m) return;
    m.textContent = msg || '';
    m.classList.toggle('pp-calcsend__msg--ok', !!ok);
  }
  function copy(box, sel) { return txt(box.querySelector(sel)); }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.hasAttribute || !f.hasAttribute('data-pp-calc-send-form')) return;
    var c = card(f);
    var box = f.querySelector('[data-pp-calc-send]');
    if (!c || !box) return;
    var body = f.querySelector('[data-pp-calc-send-body]');
    if (body) body.value = compose(c, box);
    if (!window.fetch || !window.URLSearchParams || !window.DOMParser || !window.FormData) return;
    e.preventDefault();

    var btn = f.querySelector('.pp-calcsend__btn');
    var email = f.querySelector('input[type="email"]');
    if (btn) btn.disabled = true;
    f.setAttribute('aria-busy', 'true');
    say(box, '', false);
    var action = f.getAttribute('action') || '/contact';

    function native() {
      /* keep the numbers in the address, so they come back after the check */
      try { history.replaceState(null, '', link(c)); } catch (x) {}
      f.submit();
    }
    function failed(msg) {
      say(box, msg || copy(box, '[data-pp-calc-send-fail]'), false);
      setTimeout(function () { if (email) email.focus(); }, 0);
    }

    fetch(action, { method: 'POST', body: new URLSearchParams(new FormData(f)), credentials: 'same-origin', headers: { Accept: 'text/html' } })
      .then(function (res) {
        if (/\/challenge/.test(res.url)) { native(); return 'native'; }
        return res.text().then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var err = doc.querySelector('#' + f.id + ' [data-pp-calc-send-err]');
          if (!res.ok || err) { failed(err ? txt(err) : ''); return 'failed'; }
          return 'sent';
        });
      })
      .then(function (state) {
        if (state !== 'sent') return state;
        /* add the visitor to Customers; a failure here never undoes the send */
        var p = new URLSearchParams();
        p.set('form_type', 'customer');
        p.set('utf8', '✓');
        p.set('contact[email]', email ? email.value : '');
        p.set('contact[tags]', box.getAttribute('data-tags') || '');
        return fetch(action, { method: 'POST', body: p, credentials: 'same-origin', headers: { Accept: 'text/html' } })
          .then(function () { return 'sent'; }, function () { return 'sent'; });
      })
      .then(function (state) {
        if (state !== 'sent') return;
        var row = box.querySelector('[data-pp-calc-send-row]');
        if (row) row.hidden = true;
        box.setAttribute('data-sent', '1');
        say(box, copy(box, '[data-pp-calc-send-ok]'), true);
        /* the button just disappeared with the row: keep focus in the panel */
        var m = box.querySelector('[data-pp-calc-send-msg]');
        if (m) { m.setAttribute('tabindex', '-1'); m.focus(); }
      })
      .catch(function () { failed(''); })
      .then(function () {
        if (btn) btn.disabled = false;
        f.removeAttribute('aria-busy');
      });
  });

  /* ---------- start ---------- */
  var started = false;
  function start() {
    if (started) return;
    started = true;
    Array.prototype.forEach.call(document.querySelectorAll(CARD), function (c) {
      if (restore(c)) reveal(c);
    });
  }
  /* after the calculators' own scripts have filled the card in */
  if (document.readyState === 'complete') start();
  else {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(start, 0); });
    window.addEventListener('load', start);
  }
})();
